/**
 * PHP/MySQL often exposes tinyint/boolean as 0, 1, "0", or "1".
 * In JavaScript, the string "0" is truthy, which breaks checkboxes and status badges.
 */

export function toBool(value, defaultValue = false) {
  if (value === true || value === 1 || value === '1') return true;
  if (value === false || value === 0 || value === '0') return false;
  if (value === null || value === undefined) return defaultValue;
  return Boolean(value);
}

const BOOL_KEYS = ['isActive', 'isApproved', 'featured', 'isRead', 'isVisible'];

export function normalizeEntityForAdmin(row) {
  if (!row || typeof row !== 'object') return row;
  const out = { ...row };
  for (const key of BOOL_KEYS) {
    if (Object.prototype.hasOwnProperty.call(out, key)) {
      const def = key === 'isApproved' ? false : key === 'featured' ? false : true;
      out[key] = toBool(out[key], def);
    }
  }
  return out;
}

export function normalizeListForAdmin(rows) {
  if (!Array.isArray(rows)) return rows;
  return rows.map(normalizeEntityForAdmin);
}
